Namespace 'Customer.Ticket'

class Customer.Ticket.SurveyStartingView extends Backbone.View
  template: JST['backbone/templates/customer/ticket/body/survey_starting']
  className: 'survey-notice'

  initialize: ({datetime}) ->
    @datetime = datetime

  render: ->
    @$el.html @template
      datetime: @datetime
    @
